export default "__VITE_ASSET__U5kzdXnf__"